module.exports = __webpack_public_path__ + "static/media/firstam_christine_russell.261c5ec7.jpg";